module.exports = __webpack_public_path__ + "static/about-image-388ae8c8161853febcc0880f48bda04f.jpg";